<main class="w-100 row gx-2 justify-content-center" #itemsContainer
    [ngClass]="bShowFilter ? 'gy-2' : 'gy-0 align-items-center' ">

    <header *ngIf="isMobile" class="filter-container py-2 px-3 col-12"
        [ngClass]="bShowFilter ? 'filter-container-show' : '' ">

        <form [formGroup]="searchModel"
            class="row justify-content-center align-items-center gx-0 gx-md-2 gy-3 gy-md-0 w-100 h-100">

            <!-- استان -->

            <div class="position-relative col-12 col-md-3">

                <div class="form-group has-icon">

                    <span class="form-control-icon">

                        <mat-icon class="mat-18">apartment</mat-icon>

                    </span>

                    <select (change)="getCity($event.target.value)" class="w-100" formControlName="strState">

                        <option value=""> استان </option>

                        <option *ngFor="let item of lst_Province" [value]="item?.strState">

                            {{item.strStateName}}

                        </option>

                    </select>

                </div>

            </div>

            <!-- شهر -->

            <div class="position-relative col-12 col-md-3">

                <div class="form-group has-icon">

                    <span class="form-control-icon">

                        <mat-icon class="mat-18">apartment</mat-icon>

                    </span>

                    <select class="w-100" formControlName="strCityCode">

                        <option value=""> شهر </option>

                        <option *ngFor="let item of list_City" [value]="item.strCity">

                            {{item.strCityName}}

                        </option>

                    </select>

                </div>

            </div>

            <div class="position-relative col-12 col-md-3">

                <div class="form-group has-icon">

                    <span class="form-control-icon">

                        <mat-icon class="mat-18">category</mat-icon>

                    </span>

                    <select (change)="updateCategory($event.target.value)" class="w-100"
                        formControlName="iResume_Category">

                        <option value="-1"> گروه </option>

                        <option *ngFor="let item of list_Category" [value]="item.iResume_Category">

                            {{item.strComment}}

                        </option>

                    </select>

                </div>

            </div>

            <div class="position-relative col-12 col-md-3">

                <div class="form-group has-icon">

                    <span class="form-control-icon">

                        <mat-icon class="mat-18">category</mat-icon>

                    </span>

                    <select (change)="updateSubCategory()" class="w-100" formControlName="iResume_SubCategory">

                        <option value="-1"> زیر گروه </option>

                        <option *ngFor="let item of list_SubCategory" [value]="item.iResume_SubCategory">

                            {{item.strComment}}

                        </option>

                    </select>

                </div>

            </div>

            <div class="position-relative col-12 col-md-3">

                <div class="form-group has-icon">

                    <span class="form-control-icon">

                        <mat-icon class="mat-18">manage_search</mat-icon>

                    </span>

                    <input formControlName="strSearchContent" class="form-control" type="text"
                        placeholder="جستجو در کسب و کارها... ">

                </div>

            </div>

            <div [ngClass]="bShowFilter ? 'd-none' : 'search-btn col-12 col-md-2' ">

                <button class="search-filter-btn btn btn-primary text-secondary fw-bold w-75"
                    (click)="sendLocationToApi(true)"> جستجو </button>

            </div>

        </form>

    </header>

    <div class="result-business col-12" [ngClass]="bShowMap || bShowFilter ? 'result-business-hide' : '' ">

        <span #point_1></span>

        <header *ngIf="!isMobile" class="filter-container py-2 px-3 col-12"
            [ngClass]="bShowFilter ? 'filter-container-show' : '' ">

            <form [formGroup]="searchModel"
                class="row justify-content-center align-items-center gx-0 gx-md-2 gy-3 gy-md-0 w-100 h-100">

                <!-- استان -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">apartment</mat-icon>

                        </span>

                        <select (change)="getCity($event.target.value)" class="w-100" formControlName="strState">

                            <option value=""> استان </option>

                            <option *ngFor="let item of lst_Province" [value]="item?.strState">

                                {{item.strStateName}}

                            </option>

                        </select>

                    </div>

                </div>

                <!-- شهر -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">apartment</mat-icon>

                        </span>

                        <select class="w-100" formControlName="strCityCode">

                            <option value=""> شهر </option>

                            <option *ngFor="let item of list_City" [value]="item?.strCity">

                                {{item.strCityName}}

                            </option>

                        </select>

                    </div>

                </div>

                <!-- گروه -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">category</mat-icon>

                        </span>

                        <select (change)="updateCategory($event.target.value)" class="w-100"
                            formControlName="iResume_Category">

                            <option value="-1"> گروه </option>

                            <option *ngFor="let item of list_Category" [value]="item.iResume_Category">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                </div>

                <!-- زیر گروه -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">category</mat-icon>

                        </span>

                        <select (change)="updateSubCategory()" class="w-100" formControlName="iResume_SubCategory">

                            <option value="-1"> زیر گروه </option>

                            <option *ngFor="let item of list_SubCategory" [value]="item.iResume_SubCategory">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                </div>

                <!-- جستجو در کسب و کارها -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">manage_search</mat-icon>

                        </span>

                        <input formControlName="strSearchContent" class="form-control" type="text"
                            placeholder="جستجو کنید ...">

                    </div>

                </div>

                <!-- جستجو -->

                <div [ngClass]="bShowFilter ? 'd-none' : 'search-btn col-12 col-md-2' ">

                    <button class="search-filter-btn btn btn-primary text-secondary fw-bold w-75"
                        (click)="sendLocationToApi(true)"> جستجو

                    </button>

                </div>

            </form>

        </header>

        <!-- نتایج -->

        <div class="p-2">

            <div class="d-flex justify-content-between counter-icon">

                <p class="result-title fw-bold">

                    لیست کسب و کار ها

                    <span *ngIf="list_Business.length" [ngStyle]="{'opacity' : isResultLoading ? '0.6' : ''}">

                        ( {{ ' نمایش ' + list_Business.length + ' از ' +
                        searchModel.get('iTotal')?.value.toLocaleString() | faNum }}
                        مورد )

                    </span>

                </p>

            </div>

            <div *ngIf="list_Business.length" class="result-items-container">


                <!-- کسب و کارها -->

                <div (click)="open_Business(item)" *ngFor="let item of list_Business;let i = index;let last=last"
                    class="business-items mt-3">

                    <!-- <span Infinite-Scroll *ngIf="i == 20"> </span> -->

                    <div
                        [ngClass]="isResultLoading ? 'item-loading w-100 business-information d-flex' : 'w-100 business-information d-flex pointer' ">

                        <div class="col-4 business-image">

                            <img class="w-100" loading="lazy"
                                src="{{ item.strImage != '' ? 'data:image/jpeg;base64,' + item.strImage  : ' ../../../assets/imgs/preview__thumbnail.png' }}"
                                alt="{{item.strTitle}}">

                            <span> {{item.strCityName}} </span>

                        </div>

                        <div class="col-8 business-detail" [ngClass]="item.bVIP ? 'verified-business' : '' ">

                            <div class="business-category d-flex justify-content-end">

                                <span class="fw-bold"> {{item.strResume_Category_strComment}} </span>

                            </div>

                            <div class="business-info p-2">

                                <p class="mb-1 d-flex align-items-center text-dark fw-bold">

                                    <span class="d-flex align-items-center">

                                        <mat-icon class="d-flex justify-content-center align-items-center"
                                            [ngStyle]="{'color' : item.bValid ? '#007bff' : ''}"
                                            style="font-size: 22px;">

                                            {{ item.bValid ? 'verified' : ' store' }}

                                        </mat-icon>

                                        <span style="color: #007bff;" *ngIf="item.bValid"> مورد تایید امدادران - </span>

                                    </span>

                                    <span class="business-name mx-1"> {{item.strTitle | faNum}} </span>

                                </p>

                                <p class="mb-1 d-flex align-items-center text-dark fw-bold">

                                    <span class="d-flex align-items-center">

                                        <mat-icon class="d-flex justify-content-center align-items-center"
                                            style="font-size: 21px;">today

                                        </mat-icon>

                                    </span>

                                    <span class="mx-1"> {{item.strWeekDays | faNum}} </span>

                                </p>

                                <p class="mb-1 d-flex align-items-center text-dark fw-bold">

                                    <span class="d-flex align-items-center">

                                        <mat-icon class="d-flex justify-content-center align-items-center"
                                            style="font-size: 22px;">access_time

                                        </mat-icon>

                                    </span>

                                    <span class="mx-1"> {{item.strHoursOperation | faNum}} </span>

                                </p>

                                <p *ngIf="item.strAddress" (click)="show_OnMap($event,item)"
                                    class="mb-1 d-flex align-items-center text-dark justify-content-start fw-bold">

                                    <span class="d-flex align-items-center">

                                        <mat-icon class="d-flex justify-content-center align-items-center"
                                            style="font-size: 21px;"> location_on

                                        </mat-icon>

                                    </span>

                                    <span class="mx-1" [title]="item.strAddress">

                                        {{item.strAddress}}

                                    </span>

                                </p>

                                <p class="mb-1 d-flex align-items-center text-dark fw-bold">

                                    <span class="d-flex align-items-center">

                                        <mat-icon class="d-flex justify-content-center align-items-center"
                                            style="font-size: 21px;">visibility

                                        </mat-icon>

                                    </span>

                                    <span class="mx-1"> {{item.iView + ' بازدید ' | faNum}} </span>

                                </p>

                            </div>

                        </div>

                    </div>

                </div>

                <!-- اسکرول لودینگ -->

                <div Infinite-Scroll [ngClass]="(bScrollLoading && !bDataEnded) ? 'infinite-scroll w-100' : '' ">

                    <ng-container *ngIf="bScrollLoading && !bDataEnded">

                        <div class="loader"></div>

                        <!-- <div id="wifi-loader">

                            <svg class="circle-outer" viewBox="0 0 86 86">
    
                                <circle class="back" cx="43" cy="43" r="40"></circle>
    
                                <circle class="front" cx="43" cy="43" r="40"></circle>
    
                                <circle class="new" cx="43" cy="43" r="40"></circle>
    
                            </svg>
    
                            <svg class="circle-middle" viewBox="0 0 60 60">
    
                                <circle class="back" cx="30" cy="30" r="27"></circle>
    
                                <circle class="front" cx="30" cy="30" r="27"></circle>
    
                            </svg>
    
                            <svg class="circle-inner" viewBox="0 0 34 34">
    
                                <circle class="back" cx="17" cy="17" r="14"></circle>
    
                                <circle class="front" cx="17" cy="17" r="14"></circle>
    
                            </svg>
    
                            <div class="text" data-text="Searching"></div>
    
                        </div> -->

                    </ng-container>

                </div>

                <div *ngIf="!bDataEnded" class="p-5"></div>

            </div>

        </div>

    </div>

    <div class="map-business col-12" [ngClass]="bShowMap ? 'map-business-show' : '' "
        [ngStyle]="{'pointer-events' : this.isResultLoading ? 'none' : ''}">

        <header *ngIf="!isMobile && bShowMap" class="filter-container py-2 px-3 col-12"
            [ngClass]="bShowFilter ? 'filter-container-show' : '' ">

            <form [formGroup]="searchModel"
                class="row justify-content-center align-items-center gx-0 gx-md-2 gy-3 gy-md-0 w-100 h-100">

                <!-- استان -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">apartment</mat-icon>

                        </span>

                        <select (change)="getCity($event.target.value)" class="w-100" formControlName="strState">

                            <option value=""> استان </option>

                            <option *ngFor="let item of lst_Province" [value]="item?.strState">

                                {{item.strStateName}}

                            </option>

                        </select>

                    </div>

                </div>

                <!-- شهر -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">apartment</mat-icon>

                        </span>

                        <select class="w-100" formControlName="strCityCode">

                            <option value=""> شهر </option>

                            <option *ngFor="let item of list_City" [value]="item?.strCity">

                                {{item.strCityName}}

                            </option>

                        </select>

                    </div>

                </div>

                <!-- گروه -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">category</mat-icon>

                        </span>

                        <select (change)="updateCategory($event.target.value)" class="w-100"
                            formControlName="iResume_Category">

                            <option value="-1"> گروه </option>

                            <option *ngFor="let item of list_Category" [value]="item.iResume_Category">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                </div>

                <!-- زیر گروه -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">category</mat-icon>

                        </span>

                        <select (change)="updateSubCategory()" class="w-100" formControlName="iResume_SubCategory">

                            <option value="-1"> زیر گروه </option>

                            <option *ngFor="let item of list_SubCategory" [value]="item.iResume_SubCategory">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                </div>

                <!-- جستجو در کسب و کارها -->

                <div class="position-relative col-12 col-md-2">

                    <div class="form-group has-icon">

                        <span class="form-control-icon">

                            <mat-icon class="mat-18">manage_search</mat-icon>

                        </span>

                        <input formControlName="strSearchContent" class="form-control" type="text"
                            placeholder="جستجو کنید ...">

                    </div>

                </div>

                <!-- جستجو -->

                <div [ngClass]="bShowFilter ? 'd-none' : 'search-btn col-12 col-md-2' ">

                    <button class="search-filter-btn btn btn-primary text-secondary fw-bold w-75"
                        (click)="sendLocationToApi(true)"> جستجو

                    </button>

                </div>

            </form>

        </header>

        <div id="test" style="width: 100%; height: 100%;" class="mx-auto">
            <div class="position-icon">
                <ng-container *ngIf="bShowMap">
                    <button (click)="getUserLocation()"
                        class="d-flex pointer w-100 h-100 btn btn-primary text-secondary">
                        <ng-container *ngIf="!isRequestingLocation">
                            <mat-icon>share_location</mat-icon>
                        </ng-container>
                        <ng-container *ngIf="isRequestingLocation">
                            <i class="material-icons spin-animation">
                                <mat-icon>sync</mat-icon>
                            </i>
                        </ng-container>
                    </button>
                </ng-container>

            </div>

        </div>

    </div>

    <div *ngIf="!bScrollLoading && !bShowMap" class="switch-container py-1">

        <ng-container *ngIf="bShowResult">

            <div (click)="backTo('showFilter')" *ngIf="isMobile"
                class="col-6 d-flex justify-content-center pointer align-items-center h-100 bg-gray">

                <span class="text-secondary"> فیلتر </span>

                <span class="d-flex justify-content-center align-items-center px-1">

                    <mat-icon class="mat-18 text-secondary">tune</mat-icon>

                </span>

            </div>

            <div (click)="backTo('showMap')"
                [ngClass]="isMobile ? 'col-6 btn-primary' : 'btn-secondary col-12 rounded bg-gray' "
                class="d-flex justify-content-center pointer align-items-center h-100">

                <span [ngClass]="isMobile ? '' : 'text-primary fw-bold' "> نقشه </span>

                <span class="d-flex justify-content-center align-items-center px-1">

                    <mat-icon [ngClass]="isMobile ? '' : 'text-primary' ">travel_explore</mat-icon>

                </span>

            </div>

        </ng-container>

        <ng-container *ngIf="!bShowResult">

            <div (click)="backTo('showResults')"
                class="col-12 d-flex justify-content-center pointer align-items-center h-100 bg-gray">

                <span class="text-secondary"> {{ !isDesktop ? 'جستجو کسب و کار' : 'لیست کسب و کار ها' }} </span>

                <span class="d-flex justify-content-center align-items-center px-2">

                    <mat-icon class="mat-18 text-secondary">manage_search</mat-icon>

                </span>

            </div>

        </ng-container>

    </div>

    <div id="business-tooltip" class="result-items-container" [style.top]="tooltipTop + 'px'"
        [style.left]="tooltipLeft + 'px'">

        <div (click)="open_Business(item)" *ngFor="let item of list_Tooltip" class="mt-3">

            <div [ngClass]="isResultLoading ? 'item-loading result-item' : 'result-item' ">

                <div class="business-image position-relative">

                    <img src="{{ item.strImage != '' ? 'data:image/jpeg;base64,' + item.strImage  : ' ../../../assets/imgs/preview__thumbnail.png' }}"
                        loading="lazy" alt="{{item.strTitle}}">

                    <div class="position-absolute w-100 top-0 d-flex justify-content-between p-2">

                        <div class="d-flex flex-column align-items-end">

                        </div>

                        <div class="d-flex flex-column align-items-end">

                            <span class="d-flex justify-content-center align-items-end">

                                <mat-icon (click)="likeBusiness($event,item)" style="font-size: 30px;"
                                    [ngClass]="isLiked(item) ? 'text-danger' : 'text-muted' ">favorite</mat-icon>

                            </span>

                            <div class="d-flex flex-column justify-content-center align-items-end mt-2">

                                <span class="d-flex align-items-end justify-content-start">

                                    <mat-icon style="font-size: 30px;"
                                        [ngClass]="item?.star ? 'text-warning' : 'text-muted' ">grade</mat-icon>

                                </span>

                                <span style="width:24px; max-width:24px;"
                                    class="d-flex justify-content-center ms-1 mt-1">{{ item.fScore | faNum }}</span>

                            </div>

                        </div>

                    </div>

                </div>

                <div class="business-title d-flex align-items-center mb-2">

                    <span *ngIf="!item.bValid" class="d-flex align-items-center mx-2 ">

                        <mat-icon class="text-secondary">store</mat-icon>

                    </span>

                    <span *ngIf="item.bValid" class="d-flex align-items-center mx-2 ">

                        <mat-icon style="font-size: 22px;" class="text-primary">verified</mat-icon>

                    </span>

                    <span class="fw-bold"> {{item.strTitle | faNum}} </span>

                </div>

                <div class="business-address d-flex align-items-center">

                    <span class="d-flex align-items-center mx-2 ">

                        <mat-icon (click)="straight_OnMap($event,item)" class="text-muted">pin_drop</mat-icon>

                    </span>

                    <span> {{item.strAddress | faNum }} </span>

                </div>

            </div>

        </div>

    </div>

    <!-- دکمه رفتن به بالا -->

    <div class="scrollTop-Container pointer" (click)="gotoTop()" *ngIf="bUpButton">

        <div class="d-flex justify-content-center align-items-center">

            <mat-icon sty class="text-secondary">

                arrow_upward

            </mat-icon>

        </div>

    </div>

</main>

<!-- popup نمایش تبلیغات  -->

<div class="modal  fade dir " id="modal" tabindex="4" role="dialog" aria-hidden="true"
    style="z-index:100000 !important;">

    <div style="width:90%;" class="modal-dialog modal-lg modal-dialog-centered">

        <div class="modal-content bg-gray-soft">

            <div class="modal-body p-0 ">

                <button type="button" class="btn-close m-0 btn_close" data-bs-dismiss="modal"
                    aria-label="Close"></button>

                <div class="w-100 h-100">

                    <a class="w-100" target="_blank" href="{{popAds?.strURL}}"
                        (click)="popupClick(popAds.iDyar_PopupADV)">

                        <img class="w-100" src="data:image/png;base64,{{popAds?.strIMage}}" alt="{{popAds?.strTitle}}"
                            loading="lazy">

                    </a>

                </div>

            </div>

        </div>

    </div>

</div>